const migrateAddress: {puAddress:string,pwAddress:string,wpscAddress: string, usdtAddress: string, wdcAddress:string,polyJetClubProProxy:string,
  masterchefv2:string,masterchefv3:string,masterchefv4:string,masterchefv0:string,masterchefv1:string,polyJetClub:string,pu_pid:number,pw_pid:number,RewardMappingContract:string} = {
    puAddress: '0x80424A884055632b88e0c1dD6c020FA25e424B16',
    pwAddress: '0x25A01848D5a04f53769Be96a1230dE12e1219931',
    wpscAddress: '0xebaBd3ee4E4E2B7ba378c3EbCB59fbe92A00DEF0',
    usdtAddress:'0xEF113087Fe16072fB6B109caec174d264Af6E16a',
    wdcAddress:'0x101D4507E0c07Aa929EF4Fd1eabcB7bcAef5e391',
    polyJetClubProProxy:'0x7240a8b1F2FAf5C20E6B4CD29c1d77b3d37D2462',
    masterchefv4:'0x955f4710F67004DD47c7dAEd7110DCd61783239b',
    masterchefv3:'0x955f4710F67004DD47c7dAEd7110DCd61783239b',
    masterchefv2:'0xcc697f04Ce6CAbC8B910372A7867fA190104F483',
    masterchefv0:'0x21350d703f4BDb6a4d69db8899F8C1cE67946b79',
    masterchefv1:'0xd97d9f16D586150D92981384C467CB9450f8EBc4',
    polyJetClub:'0xC04cb528Ef1c182d053e84bf1705C9E2b2a3deAf',
    pu_pid:0,
    pw_pid:1,
    RewardMappingContract: '0x348e99C9f0993E42fE5bed71b9E3D2a27a95cF46' // '0xd613D723bF06E3B960c73DC39B675215CE3Be0a0' v4

  }
  
  export default migrateAddress